import * as constants from './constants';

export const setGTM = (submit, dataPage) => ({
  type: constants.SET_GTM,
  payload: {
    submit: submit,
    dataPage: dataPage,
  },
});

export const setBranch = (
  submit?: any,
  databranch?: any,
  isBranch?: any,
  isSalesmen?: any,
  isDetailBranch?: any,
  isDetailSalesman?: any,
  isLayananBengkel?: any
) => ({
  type: constants.SET_DATA_BRANCH,
  payload: {
    submit: submit,
    databranch: databranch,
    isBranch: isBranch,
    isSalesmen: isSalesmen,
    isDetailBranch: isDetailBranch,
    isDetailSalesman: isDetailSalesman,
    isLayananBengkel: isLayananBengkel || false,
  },
});

export const resetBranch = () => ({
  type: constants.SET_DATA_BRANCH,
  payload: {},
});

export const setPageBranch = (page) => ({
  type: constants.SET_PAGE_BRANCH,
  payload: {
    page: page,
  },
});

export const setProduct = (submit, productCategory, productArticle) => ({
  type: constants.SET_DATA_PRODUCT,
  payload: {
    submit: submit,
    productCategory: productCategory,
    productArticle: productArticle,
  },
});

export const resetProduct = () => ({
  type: constants.SET_DATA_PRODUCT,
  payload: {},
});

export const setNewCar = (submit) => ({
  type: constants.SET_DATA_NEW_CAR,
  payload: {
    submit: submit,
  },
});

export const setFilterCoupon = (param) => ({
  type: constants.SET_FILTER_COUPON,
  payload: {
    isDiskon: param,
  },
});

export const setCategoryService = (param) => ({
  type: constants.SET_CATEGORY_SERVICE,
  payload: param,
});

export const setIsGTMReady = (param) => ({
  type: constants.SET_IS_GTM_READY,
  payload: param,
});

export const setQuicklink = (submit) => ({
  type: constants.SET_DATA_QUICKLINK,
  payload: {
    submit: submit,
  },
});

export const setTrendingCar = (submit) => ({
  type: constants.SET_DATA_TRENDING_CAR,
  payload: {
    submit: submit,
  },
});

export const setSimulationCredit = (data) => ({
  type: constants.SET_DATA_SIMULATION_CREDIT,
  payload: data,
});

export const resetSimulationCredit = () => ({
  type: constants.RESET_DATA_SIMULATION_CREDIT,
  payload: null,
});

export const setGetAdviceUsedCarDataGTM = (data) => ({
  type: constants.SET_DATA_GET_ADVICE_USED_CAR,
  payload: data,
});
